import React, { Component } from "react";
import { Table } from "antd";

const { Column } = Table;

export default class LadderTable extends Component {
	render() {
		const ladder = this.props.dataLadder;
		const solvedProblems = this.props.solved;
	
		const dataSource = ladder.problems.map(problem => {
			const solved = solvedProblems.has(`${problem.idContest}/${problem.indexProblem}`);
			return {
				key: problem.id,
				id: problem.id,
				level: problem.level,
				name: problem.name,
				url: problem.url,
				status: solved
			}
		});

		const green = "#5AA900";

		return (
			<Table dataSource={dataSource} size="small" pagination={false}>
				<Column
					title="Id"
					dataIndex="id"
					key="id"
					render={(text, record) => ({
						props: {
							style: { background: (record.status?green:"none"), color: record.status?"white":""},
						},
						children: <div>{ text }</div>	
					})}
				/>
				<Column
					title="Name"
					dataIndex="name"
					key="name"
					render={(text, record) => ({
						props: {
							style: { background: (record.status?green:"none")},
						},
						children: <a href={ record.url } target="blank" style={{color: record.status?"white":""}}>{text}</a>
					})}
				/>
				<Column
					title="Level"
					dataIndex="level"
					key="level"
					render={(text, record) => ({
						props: {
							style: { background: (record.status?green:"none"), color: record.status?"white":""},
						},
						children: <div>{ text }</div>	
					})}
				/>
				
				<Column
					title="Status"
					dataIndex="status"
					key="status"
					render={status => ({
						props: {
							style: { background: (status?green:"none"), color: status?"white":"", textAlign: "center" },
						},
						children: <div>{status?"AC":"-"}</div>	
					})}
				/>
			</Table>
		);
	}
}
